<template>
  <landing-pages-list :filters="filters" hide-job-board/>
</template>
<script>
  import LandingPagesList from 'src/views/admin/content/landing-pages/LandingPagesList'

  export default {
    components: {
      LandingPagesList
    },
    computed: {
      filters() {
        return [
          {
            key: 'match[job_board_id]',
            value: this.$route.params.id
          }
        ]
      }
    }
  }
</script>
<style>
</style>
